import { supabase } from '../config/supabase';
import type { DispatchRecommendation } from '../types/database';

export async function recommendDispatchAssignments(
  tripId: string,
  limit = 5
): Promise<DispatchRecommendation[]> {
  const { data, error } = await supabase.rpc('recommend_dispatch_assignments', {
    p_trip_id: tripId,
    p_limit: limit,
  });

  if (error) throw new Error(error.message);
  return (data ?? []) as DispatchRecommendation[];
}
